import React from 'react';

import { Route, Switch } from 'react-router-dom';

import { CompiledStepsProvider } from 'client/app/apps/disco-prototype/CompiledStepsProvider';
import DefineLiquidSetPage from 'client/app/apps/disco-prototype/DefineLiquidSetPage';
import Demov2Page from 'client/app/apps/disco-prototype/Demov2Page';
import { DeviceConfigProvider } from 'client/app/apps/disco-prototype/DeviceConfigProvider';
import DiscoPrototypeLayout from 'client/app/apps/disco-prototype/Layout';
import MakeMixturePage from 'client/app/apps/disco-prototype/MakeMixturePage';
import { PlateProvider } from 'client/app/apps/disco-prototype/PlateProvider';
import { StateProvider } from 'client/app/apps/disco-prototype/StateProvider';
import UploadDataPage from 'client/app/apps/disco-prototype/UploadDataPage';
import { ScreenRegistry } from 'client/app/registry';
import Screen404 from 'common/ui/components/Screen404';
import { route } from 'common/ui/navigation';

export const discoPrototypeRoutes = {
  root: route<void>(`/${ScreenRegistry.DISCO_PROTOTYPE}`),
  uploadData: route<void>(`/${ScreenRegistry.DISCO_PROTOTYPE}/upload-data`),
  defineLiguidSet: route<void>(`/${ScreenRegistry.DISCO_PROTOTYPE}/define-liquid-set`),
  defineMethod: route<void>(`/${ScreenRegistry.DISCO_PROTOTYPE}/define-method`),
  demov2: route<void>(`/${ScreenRegistry.DISCO_PROTOTYPE}/demo-v2`),
  makeMixture: route<{ stepId: string; actionId: string }>(
    `/${ScreenRegistry.DISCO_PROTOTYPE}/make-mixture/:stepId/:actionId`,
  ),
};

export function DiscoPrototypeRouter() {
  return (
    <PlateProvider>
      <DeviceConfigProvider>
        <StateProvider>
          <DiscoPrototypeLayout>
            <CompiledStepsProvider>
              <Switch>
                <Route
                  exact
                  path={discoPrototypeRoutes.uploadData.pathTemplate}
                  render={() => <UploadDataPage />}
                />
                <Route
                  exact
                  path={discoPrototypeRoutes.defineLiguidSet.pathTemplate}
                  render={() => <DefineLiquidSetPage />}
                />
                <Route
                  exact
                  path={discoPrototypeRoutes.root.pathTemplate}
                  render={() => <Demov2Page />}
                />
                <Route
                  exact
                  path={discoPrototypeRoutes.makeMixture.pathTemplate}
                  render={() => <MakeMixturePage />}
                />
                <Route component={Screen404} />
              </Switch>
            </CompiledStepsProvider>
          </DiscoPrototypeLayout>
        </StateProvider>
      </DeviceConfigProvider>
    </PlateProvider>
  );
}
